export enum UserActivityLogType {
  OpenProcessPage = 1,
  OpenUnitPage = 2,
  OpenDocument = 3,
  DownloadDocument = 4,
  IMSOopen = 5,
}
